import { trackV2 } from "../util/track-ga-event";

/** Not an action dispatcher */
export const track = (eventName: string, eventLabel?: string, others = {}, noLabel = false) =>
    trackV2(eventName, eventLabel ? (noLabel ? eventLabel : `label=${eventLabel}`) : undefined, others);

